<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <div class='h-toolbarBg'>
          <ejs-toolbar>
            <e-items>
              <e-item prefixIcon='icon hero-icon hero-icon-remove' tooltipText='删除' :click='delDialog'></e-item>
              <e-item prefixIcon='icon hero-icon hero-icon-edit' tooltipText='编辑' :click='editDialog'></e-item>
              <e-item prefixIcon='icon hero-icon hero-icon-refresh' tooltipText='刷新' :click='getServiceList'></e-item>
              <e-item prefixIcon='icon hero-icon hero-icon-add' tooltipText='上传服务包' :click='addDialog'></e-item>
            </e-items>
          </ejs-toolbar>
          <div class='h-inputBox'>
            <input class='e-input' placeholder='请输入服务名称' @keyup.enter='filter' v-model='keyword' maxLength='15' />
          </div>
        </div>
        <div class='h100-40 noPage'>
          <!--<ejs-grid ref='grid' height='calc(100vh - 280px)'>-->
            <!--<e-columns>-->
              <!--<e-column field='serviceName' headerText='网元&服务名称' width='70' :showCheckbox='true'></e-column>-->
              <!--<e-column field='introduction' headerText='介绍' width='70' textAlign='Left'></e-column>-->
              <!--<e-column field='type' headerText='分类' width='90' textAlign='Left'></e-column>-->
              <!--<e-column field='instanceNum' headerText='部署总次数' width='90' textAlign='Middle'></e-column>-->
              <!--<e-column field='createTime' headerText='上架时间' width='90' textAlign='Middle'></e-column>-->
              <!--<e-column field='idFlag' headerText='操作' width='90' :template='detailTemplate'></e-column>-->
            <!--</e-columns>-->
          <!--</ejs-grid>-->
          <Table ref="grid"></Table>
        </div>
      </div>
      <CustomDialog ref='upload' :element='upload.element' :styles='upload.styles'>
        <template v-slot:dialog-content>
          <AddDialog ref='addObj'></AddDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='serverDetailPage' :element='dialog.eleServerDetailPage' :styles='dialog.styles'>
        <template v-slot:dialog-content>
        <ServerDetailDialog ref='serverDetail'></ServerDetailDialog>
        </template>
      </CustomDialog>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import qs from 'qs';
import AddDialog from '../../../components/deploymentManagement/serverManagement/addDialog';
import CustomDialog from '../../../components/common/CustomDialog';
import { EventBus } from '../../../plugins/eventBus';
import { CommandColumn  } from "@syncfusion/ej2-vue-grids";
import detailTemplate from '../../../components/deploymentManagement/deployedInstance/DetailTemplate';
import ServerDetailDialog from '../../../components/deploymentManagement/deployedInstance/ServerDetailDialog';
import Table from '../../../components/deploymentManagement/serverManagement/Table';

export default {
  name: 'ServerManagement',
  provide: {
    grid: [ CommandColumn ]
  },
  components: {
    BasicLayout,
    AddDialog,
    CustomDialog,
    ServerDetailDialog,
    Table
  },
  data() {
    return {
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: '部署管理/服务管理' },
      editSettings: { allowEditing: true, allowDeleting: true },
      commands: [{ type: 'Edit', buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' } },
        { buttonOption: { cssClass:'e-link', content: 'delete', click: this.onClick } }],
      keyword: '',
      upload: {
        styles: {
          width: '810px',
          height: '752px',
          model: true,
          visible: false
        },
        element: {
          refName: "detailLog",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Common.cancel') } },
            {
              click: this.confirm,
              buttonModel: {
                content: `${this.$t("Common.confirm")}`,
                isPrimary: true
              }
            }
          ],
          title: this.$t('上传软件包')
        }
      },
      dialog: {
        eleServerDetailPage: {
          target: this.$refs.serverDetail,
          refName: 'serverDetail',
          buttonGroup: [
            {
              click: this.closeServerDetailPage,
              buttonModel: { content: this.$t('SubscriberIms.cancel') }
            }
          ],
          title: this.$t('DeployManagement.detail'),
          isClose: true
        },
        styles: {
          width: '55%',
          height: '80%',
          visible: false,
          model: true
        }
      },
      neMap: {
        0: this.$t('System.neOAM'),
        3: this.$t('Topo.neMME'),
        4: this.$t('Topo.neHSS'),
        5: this.$t('Topo.nePGW'),
        6: this.$t('Topo.neSGW'),
        7: this.$t('Topo.nePCRF'),
        8: this.$t('Topo.neTCF'),
        9: this.$t('Topo.neTMF'),
        10: this.$t('Topo.nePDTGW'),
        11: this.$t('Topo.neDBS'),
        12: this.$t('Topo.neMC_CMS'),
        13: this.$t('Topo.neMC_CF'),
        14: this.$t('Topo.neMC_GMS'),
        15: this.$t('Topo.neMC_IDMS'),
        16: this.$t('Topo.neMC_PF'),
        17: this.$t('Topo.neBM_SC'),
        18: this.$t('Topo.neMBMS_GW'),
        19: this.$t('Topo.neFRS'),
        20: this.$t('Topo.neMC_TMF'),
        21: this.$t('Topo.nePRES'),
        23: this.$t('Topo.neP_HSS'),
        24: this.$t('Topo.neMC_KMS'),
        27: this.$t('Topo.neMCE'),
        28: this.$t('Topo.nePCDR'),
        31: this.$t('Topo.neDMS'),
        34: this.$t('Topo.neMC_GMS_NODE'),
        35: this.$t('Topo.neCU'),
        36: this.$t('Topo.neDU'),
        10001: this.$t('System.epcOAM'),
        10002: this.$t('System.imsOAM'),
        10003: this.$t('System.mcsOAM'),
        10004: this.$t('System.enodeb'),
        10007: this.$t('System.ibs_b'),
        10010: this.$t('System.ims_hytalk'),
        20001: this.$t('System.mcscl')
      },
      neType: {
        0: '基础',
        1: '业务'
      },
      detailTemplate(args) {
        return {
          template: detailTemplate
        };
      },
      timeOut: 30*1000
    };
  },
  methods: {
    addDialog() {
      this.$refs.upload.show();
    },
    delDialog() {
      const selectedData = this.$refs.grid.getParam();
      if (selectedData == null) {
        return null;
      }
      this.$layer.confirm({
        msg: this.$t('System.delPkgTip'),
        btn1: {
          msg: this.$t('System.confirm'),
          func: this.delSerPkg
        }
      });
    },
    getServiceList() {
      this.$refs.grid.init(1);
    },
    editDialog() {

    },
    filter() {
      // 前台过滤
    },
    delSerPkg() {
      const selectedData = this.$refs.grid.getParam();
      console.log('delSerPkg');
      console.log(selectedData);
      const url = '/lte/ems/packageManager/deletePackage';
      const models = [];
      selectedData.forEach(item => {
        const obj = {};
        obj.deliverType = item['deliverType'];
        obj.oamTypeCode = item['serviceId'];
        // obj.pkgVersion = "";
        // TODO
        obj.pkgVersion = "MCS_V3.0.07.040";
        models.push(obj);
      });
      this.$loading.showLoadding(this.$t('System.deleteFile'), '');
      this.axios.post(url, models).then(res => {
        console.log('delSerPkg');
        console.log(res.data);
        this.$loading.hideLoadding();
      });
    },
    onClick(args) {
      console.log(args);
    },
    dialogHide() {
      this.$refs.upload.clear();
      this.$refs.upload.close();
    },
    async confirm() {
      // this.$refs.upload.close();
      // this.$refs.addObj.upload();
      const check = this.$refs.addObj.check();
      if (!check) {
        return null;
      }
      const exist = await this.checkExistPackage();
      this.$loading.showLoadding();
      if (exist) {
        //  存在直接解压
        this.againUpload();
      } else {
        this.firstUpload();
      }
    },
    getParam(){
      return this.$refs.addObj.getParam();
    },
    async checkExistPackage(){
      const url = '/lte/ems/packageManager/isPackageExist';
      const data = this.getParam();
      const fileName = data['file']['name'];
      const params = {
        fileName: fileName
      };
      let exist = new Boolean();
      await this.axios.get(url, { params }).then(res => {
        exist = res.data;
      });
      return exist;
    },
    againUpload() {
      const url = '/lte/ems/packageManager/againUpload';
      const data = this.getParam();
      const fileName = data['file']['name'];
      const params = {
        fileName: fileName,
        adapterVersion: data['version']
      };
      this.axios.get(url, { params }).then(res => {
        setTimeout(
          this.getUploadResult(fileName),
          this.timeOut
        );
      });
    },
    firstUpload() {
      const data = this.getParam();
      const fileName = data['file']['name'];
      const url = '/lte/ems/packageManager/uploadPackage';
      const formData = new FormData();
      formData.append('type', data['type']);
      formData.append('file', data['file']);
      formData.append('version', data['version']);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        timeout: 60 * 6 * 1000
      };
      this.axios.post(url, formData, config).then(res => {
        setTimeout(
          this.getUploadResult(fileName),
          this.timeOut
        );
      });
    },
    getUploadResult(fileName) {
      //  轮询检查上传结果
      const url = '/lte/ems/packageManager/getUploadResult';
      const params = {
        fileName: fileName
      };
      this.$axios.get(url, { params }).then(res => {
        const success = res.data;
        if (success) {
          this.$loading.hideLoadding();
          this.dialogHide();
          this.getServiceList();
        } else {
          setTimeout(
            'this.getUploadResult(fileName)',
            this.timeOut
          );
        }
      });
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    },
    openServerDetailPage(target) {
      console.log('target=', target);
      this.$refs.serverDetail.setQryParam(target.serviceId, '');
      this.$refs.serverDetailPage.show();
      this.$refs.serverDetail.initTable(target);
    },
    closeServerDetailPage() {
      this.$refs.serverDetailPage.clear();
      this.$refs.serverDetailPage.close();
    }
  },
  mounted() {
    // this.getServiceList();
    this.$refs.grid.init(1);
  },
  created() {
    EventBus.$on('openDetailPage', target => {
      this.openServerDetailPage(target);
    });
  }
  // provide: {
  //   grid: [CommandColumn]
  // }
};
</script>

